export default __webpack_public_path__ + "locales/ro/RoomLogoCover.json?hash=9df80808b1ab1ba633efaec701fc95a7";